<template functional>
  <div
    v-if="typeof props.copyText !== 'undefined'"
    class="truncated-text-copy"
    :class="props.customClass"
  >
    <div
      class="overflow-ellipsis truncated-text-copy__value"
      :title="props.title || props.copyText"
    >
      <slot />
    </div>

    <a
      v-if="!props.hideCopyButton"
      v-clipboard="{ copyText: props.copyText }"
      v-tooltip="'Copy'"
      :placement="placement"
      class="btn btn-link m-l-5 p-0 no_border truncated-text-copy__icon"
      :class="{
        'truncated-text-copy__icon--visible': props.alwaysShowCopyButton,
      }"
    >
      <i class="typcn typcn-tabs-outline" />
    </a>

    <slot name="extras" />
  </div>
</template>

<script>
export default {
  name: 'TruncatedTextCopy',
  props: {
    title: {
      type: String,
      default: null,
    },
    copyText: {
      type: [String, Number, Boolean],
      default: '',
    },
    hideCopyButton: {
      type: Boolean,
      default: false,
    },
    customClass: {
      type: String,
      default: '',
    },
    placement: {
      type: String,
      default: 'right',
    },
    alwaysShowCopyButton: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style>
</style>